import { IState } from '../types';
import { getSelectedNativeCaption, getSelectedTargetCaption } from '../current-video/selectors';
import { IVideoItem } from './types';
import { ICaptionsItem } from '../../types/common';
import { EMPTY_ARRAY } from '../../../common/types';

export const getVideo = (state: IState): IVideoItem => {
  return state.videos || null;
};

export const isVideoCaptionsEmpty = (state: IState) => {
  return getVideo(state)?.captionsEmpty || false;
}

export const getTargetCaptions = (state: IState): ICaptionsItem[] => {
  const captions = getVideoCaptions(state);
  const targetLanguage = getSelectedTargetCaption(state);
  return targetLanguage && captions ? captions[targetLanguage.code] || [] : [];
};

let lastTargetCaptions: ICaptionsItem[] | undefined;
let lastTargetCaptionTexts: string[] = EMPTY_ARRAY;

// same array while the captions are the same, so memoized consumers don't recompute
export const getTargetCaptionTexts = (state: IState): string[] => {
  const captions = getTargetCaptions(state);
  if (captions !== lastTargetCaptions) {
    lastTargetCaptions = captions;
    lastTargetCaptionTexts = captions.length ? captions.map(c => c.text) : EMPTY_ARRAY;
  }
  return lastTargetCaptionTexts;
};

export const getNativeCaptions = (state: IState) => {
  const captions = getVideoCaptions(state);
  const nativeLanguage = getSelectedNativeCaption(state);
  return nativeLanguage && captions ? captions[nativeLanguage.code] || [] : [];
};

const getVideoCaptions = (state: IState) => {
  const video = getVideo(state);
  return video ? video.captions : {};
};
